
export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center bg-cover bg-center" style={{
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/64224cf19af321db9c8b874281c8e41c.jpg')`
    }}>
      <div className="w-full px-6 lg:px-12 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <h2 className="text-5xl lg:text-6xl font-['Fraunces'] font-semibold text-white mb-6 leading-tight">
              Restore Balance Through Healing Touch
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Experience the ancient wisdom of Chinese medicine combined with modern therapeutic massage techniques. Your journey to wellness begins here in Qatar.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="px-8 py-4 bg-teal-600 text-white rounded-full hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                Book Free Consultation
              </a>
              <a href="#services" className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
                Explore Services
              </a>
            </div>
            <div className="mt-12 flex items-center gap-8 text-white">
              <div>
                <div className="text-3xl font-bold">15+</div>
                <div className="text-sm text-white/80">Years Experience</div>
              </div>
              <div className="w-px h-12 bg-white/30"></div>
              <div>
                <div className="text-3xl font-bold">2000+</div>
                <div className="text-sm text-white/80">Happy Clients</div>
              </div>
              <div className="w-px h-12 bg-white/30"></div>
              <div>
                <div className="text-3xl font-bold">98%</div>
                <div className="text-sm text-white/80">Satisfaction Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
